import React from 'react';

import BackArrowImg from '../../images/svg/icons/SignUpBackArrow.svg';
import theme from '../../style/theme';

import PressableWithOpacityFeedback from './PressableWithOpacityFeedback';

const BACK_ICON_SIZE = 24;

export interface BackChevronProps {
  onPress: () => void;
  testID?: string;
}

/**
 * The unlabeled back chevron used by the sign-up flow. For the labeled
 * variant with visible "Back" text, see the separate, still-current
 * `rewards/BackButton`.
 */
const BackChevron = ({onPress, testID = 'backChevron'}: BackChevronProps) => (
  <PressableWithOpacityFeedback
    onPress={onPress}
    accessibilityRole="button"
    accessibilityLabel="Back"
    testID={testID}>
    {/* Decorative: the Pressable carries the role and the label. */}
    <BackArrowImg
      width={BACK_ICON_SIZE}
      height={BACK_ICON_SIZE}
      color={theme.colour.text.link.primary}
      aria-hidden={true}
    />
  </PressableWithOpacityFeedback>
);

export default BackChevron;
